import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import { Modal, message, Tag } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    {
        key: '$index',
        label: '序号'
    },
    {
        key: 'orgName',
        label: '部门名称',
        width: 100
    },
    {
        key: 'employeeCode',
        label: '职工编号',
        width: 100
    },
    {
        key: 'employeeName',
        label: '职工姓名',
        width: 100
    },
    {
        key: 'employeeCode2',
        label: '职工编号(更正后)',
        width: 130
    },
    {
        key: 'employeeName2',
        label: '职工姓名（更正后）',
        width: 130
    },
    {
        key: 'type',
        label: '类型',
        render: (value) => {
            if (value === 1) {
                return <span>
                <Tag color="#108ee9" >更正测评明细</Tag></span>
            }
        },
        width: 100
    },
    {
        key: 'totalCount',
        label: '总记录数',
        width: 80
    },
    {
        key: 'operatorName',
        label: '操作者',
        width: 100
    },
    {
        key: 'createTime',
        label: '操作时间',
        width: 100

    }

]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('dataCorrection/query?' + params.join('&'), keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

const queryDetail = (id) => {
    return fetch.get(`develop/student/result/detail/${id}`);
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const remove = (data) => {
    return fetch.post(`dataCenterAdmin/removeApprovalApply`, data);
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    remove
}